import { DatePipe } from '@angular/common';
import {
  Component,
  Injector,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import {
  ActionType,
  ConfirmationType,
  Modules,
  NotificationDetails,
  NotificationHeader,
  NotificationTextMessage,
} from '@app/core/Enum';
import { ExportType, MainListParameters } from '@app/core/Models';
import { BankTransactionModel } from '@app/core/Models/bank/bank-overview/bank-overview';
import {
  CommonService,
  HighlightRow,
  NotificationService,
} from '@app/core/Services';
import {
  BankOverviewState,
  Export,
  GetBankTrasnactions,
  GetCashInHandTrasnactions,
  MenuState,
} from '@app/core/Store';
import {
  BankDashboardComponent,
  ConfirmationBoxComponent,
  MatchJournalsComponent,
  ViewReceiptComponent,
} from '@app/modules';
import { TransactionHeaderComponent } from '@app/modules/transactions';
import { Select, Store } from '@ngxs/store';
import { Guid } from 'guid-typescript';
import { NgxSpinnerService, Spinner } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-bank-overview',
  templateUrl: './bank-overview.component.html',
  styleUrls: ['./bank-overview.component.scss'],
})
export class BankOverviewComponent implements OnInit {
  dialog: MatDialog;
  spinner: NgxSpinnerService;
  isExpanded = true;
  customId: any;
  showPaginator = true;
  totalSelectedRecords = 0;
  listParameters: MainListParameters = new MainListParameters();
  bankTransactions: BankTransactionModel[];
  isRowHighlighted = false;
  noDataFound = false;
  moduleEnum = Modules;
  isHeaderChange = false;
  selectedRowIndex = -1;
  moreActionCount = 4;
  ids: Array<Guid>;
  notify: NotificationService;

  actions: any = [];

  receiptList: any[] = [];
  paymentList: any[] = [];
  tempReceiptList: any[] = [];
  tempPaymentList: any[] = [];
  isAllSelected: any;
  isCheckBoxDisabled: boolean = true;

  @Select(BankOverviewState.totalRecord)
  totalRecord$: Observable<number>;

  @ViewChild(TransactionHeaderComponent, { static: true })
  headerDetails;

  @ViewChild(BankDashboardComponent, { static: true })
  dashboard;

  @Select(MenuState.moduleId)
  moduleId$: Observable<number>;

  triggerPaginationChange: Subject<any> = new Subject<any>();

  triggerHeaderChange: Subject<any> = new Subject<any>();
  triggerTabChange: Subject<any> = new Subject<any>();
  isBankDetails:boolean=true;
  displayedColumns: string[] = [
    'srNo',
    'date',
    'refNo',
    'contact',
    'reference',
    'receipts',
    'payments',
    'Balance',
    'transactionID',
    'status',
    'explain',
    'action',
  ];
  datepipe: DatePipe;

  @ViewChild(MatSort) sort: MatSort;

  @Select(MenuState.getSelectedMenuPermission)
  isViewPermission$: Observable<any>;
  actionTypeEnum = ActionType;
  isBankTranferChangePermission: boolean = true;
  isJournalChangePermission: boolean = true;
  isImportChangePermission: boolean = true;
  isRecieptChangePermission: boolean = true;
  isPaymentChangePermission: boolean = true;
  isDonationChangePermission: boolean = true;

  cashInHandTransactions: BankTransactionModel[];
  cashInHandDetails: any;
  cashInHandnoDataFound = false;
  isCash: boolean = false;
  displayedColumns1: string[] = [
    'srNo',
    'date',
    'refNo',
    'contact',
    'reference',
    'receipts',
    'payments',
    'Balance',
    'action',
  ];
  exportType = ExportType;
  cashactions: any = [];

  isBankAccordionExpanded = true;    
  isCashAccordionExpanded = false;
  
  selectedBankId: Guid;

  constructor(
    private injector: Injector,
    private store: Store,
    private highlightRow: HighlightRow,
    public commonService: CommonService,
    private renderer: Renderer2,
    private route: ActivatedRoute
  ) {
    this.dialog = injector.get<MatDialog>(MatDialog);
    this.datepipe = injector.get<DatePipe>(DatePipe);
    this.spinner = injector.get<NgxSpinnerService>(NgxSpinnerService);
    this.notify = injector.get<NotificationService>(NotificationService);
    this.receiptList = this.commonService.receiptList;
    this.paymentList = this.commonService.paymentList;
  }

  ngOnInit(): void {
   
    const accordion = history.state.accordion;
    if (accordion === 'cash') {
      this.isBankAccordionExpanded = false;
      this.isCashAccordionExpanded = true;
      this.isBankDetails = false;
    } else {
      this.isBankAccordionExpanded = true;
      this.isCashAccordionExpanded = false;
      this.isBankDetails = true;
    }
    this.triggerTabChange.next(this.isBankDetails);
    this.actions = [
      {
        name: 'Edit',
        actionType: ActionType.Update,
        icon: 'edit',
      },
      {
        name: 'Delete',
        actionType: ActionType.Delete,
        icon: 'delete_outline',
      },
    ];
    this.cashactions=[{
      name: 'Delete',
      actionType: ActionType.Delete,
      icon: 'delete_outline',
    },]
    if (this.commonService.getLocalStorage('isCashinhand')) {
      this.isCash = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.isBankTranferChangePermission = this.commonService.checkPermission(
        Modules.Bank,
        Modules.BankTransfer
      );
      this.isJournalChangePermission = this.commonService.checkPermission(
        Modules.Tasks,
        Modules.Journals
      );
      this.isRecieptChangePermission = this.commonService.checkPermission(
        Modules.Income,
        Modules.Receipt
      );
      this.isPaymentChangePermission = this.commonService.checkPermission(
        Modules.Expenditure,
        Modules.Payment
      );
      this.isDonationChangePermission = this.commonService.checkPermission(
        Modules.Donation,
        Modules.Donations
      );
    }, 3000);
  }

  getDataFromBank(data: any): void {
    this.selectedBankId = data.id;
    this.isExpanded = true;
    this.isBankDetails = true;
    this.isHeaderChange = true;
    this.isExpanded = data.isExpanded;
    this.listParameters.pageNumber = 1;
    this.listParameters.moduleId = data.id;
    this.headerDetails.headerData.moduleId = data.id;
    this.customId = data.id;
    this.isBankDetails=true;
    this.getList();

    if (this.isBankDetails && !this.isCash) {
      this.getList();
    } else {
      this.isBankDetails = false;
      this.getCashInHandList();
    }
  }

  getList(): void {
    if (
      this.listParameters.moduleId !== undefined &&
      this.listParameters.moduleId !== null &&
      this.listParameters.moduleId !== (Guid.EMPTY as unknown as Guid)
    ) {
      this.spinner.show();
      this.store
        .dispatch(new GetBankTrasnactions(this.getParamter()))
        .pipe()
        .subscribe((res) => {
          this.bankTransactions = res.bankOverview.getBankTransactions;
          this.bankTransactions.forEach(item => {
            this.commonService
              .isDataInLockedPeriod([item.id], item.moduleId)
              .subscribe(isLocked => {
                item.isPeriodLocked = !isLocked; 
              });
          });
          this.noDataFound = this.bankTransactions.length > 0 ? false : true;
          const param = {
            pageSize: this.listParameters.pageSize,
            totalRecord: res.bankOverview.totalRecord,
            isHeaderChange: this.isHeaderChange,
          };
          this.triggerPaginationChange.next(param);
        });
    }
  }

  sorting(sortBy: string, sortOrder: string): void {
    this.listParameters.sortOrder = sortOrder === 'asc' ? true : false;
    this.listParameters.sortBy = sortBy;
    this.isHeaderChange = false;
    if (this.isBankDetails) {
      this.getList();
    } else {
      this.getCashInHandList();
    }
  }

  getParamter(format?: number, isPrint?: boolean): any {
    const queryParams = {
      pageNumber: this.listParameters.pageNumber,
      pageSize: this.listParameters.pageSize,
      filter: this.listParameters.filter,
      sortBy: this.listParameters.sortBy,
      sortOrder: this.listParameters.sortOrder,
      search: this.listParameters.search,
      moduleId: this.listParameters.moduleId ?? (Guid.EMPTY as unknown as Guid),
      subModuleId: this.listParameters.subModuleId ?? -1,
      ids: this.ids ?? null,
      startDate:
        this.datepipe
          .transform(this.listParameters.startDate, 'yyyy-MM-dd')
          ?.toString() ?? null,
      endDate:
        this.datepipe
          .transform(this.listParameters.endDate, 'yyyy-MM-dd')
          ?.toString() ?? null,
      format: format,
      isPrint: isPrint,
    };
    return queryParams;
  }

  export(format: number, isPrint?: boolean, grid?: number): void {
    let totalRecordOfRecords = 0;

    this.totalRecord$.subscribe((x) => {
      totalRecordOfRecords = x;
    });

    this.spinner.show();
    if (totalRecordOfRecords > 0) {
      this.store
        .dispatch(
          new Export(
            this.getParamter(format, isPrint),
            grid === this.moduleEnum.BankDashboardBankAccount  ? this.moduleEnum.BankDashboardBankAccount : this.moduleEnum.BankDashboard
          )
        )
        .subscribe();
    } else {
      this.spinner.hide();
      this.notify.error(
        NotificationHeader.error,
        NotificationTextMessage.noDataToExport
      );
    }
  }

  checkIsCustom(event: any): void {
    this.customId = event.id;
  }

  pageChanged(pageIndex: number): void {
    if (this.listParameters.pageNumber !== pageIndex) {
      this.listParameters.pageNumber = pageIndex;
      this.isHeaderChange = false;
      
      if (this.isBankDetails) {
        this.getList();
      } else {
        this.getCashInHandList();
      }
    }
  }

  pageSizeVal(val: any): void {
    this.listParameters.pageNumber = 1;
    this.listParameters.pageSize = val;
    this.isHeaderChange = false;

    if (this.isBankDetails) {
      this.getList();
    } else {
      this.getCashInHandList();
    }
  }

  togglePaginator(val: any): void {
    this.showPaginator = val;
  }

  scrollIntoView(element) {
    if (element.accountValue !== '') {
      this.commonService.autoScrollMatAutoComplete(this.renderer);
    }
  }

  receiptPaymentChange(event: any, data: any): void {
    if (event.moduleId !== Modules.MatchJournal) {
      this.commonService.onEditRouting(
        false,
        event.moduleId,
        data.id,
        true,
        undefined,
        !data.isBankFeed,
        this.customId
      );
    } else {
      const params = {
        transactionId: btoa(data.id),
      };
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = params;
      this.dialog
        .open(MatchJournalsComponent, dialogConfig)
        .afterClosed()
        .subscribe((result) => {
          this.getList();
          this.cancelSelectionClick();
          this.dashboard.getAllBankAccount(this.customId);
        });
    }
  }

  getDataFromHeader(data: any): void {
    this.getFilterData(data);
  }

  /** Handles filter/search changes from header; detects period changes to refresh cash in hand API */
  getFilterData(data: any): void {
    const previousModuleId = this.listParameters.moduleId;
    const previousStartDate = this.normalizeFilterDate(this.listParameters.startDate);
    const previousEndDate = this.normalizeFilterDate(this.listParameters.endDate);

    if (data.search === '') {
      this.spinner.show();
    }

    if (this.listParameters.filter > -1) {
      this.isCheckBoxDisabled = false;
    } else {
      this.isCheckBoxDisabled = true;
    }

    this.isHeaderChange = true;
    // Merge new filter data with existing listParameters to preserve moduleId and other props
    this.listParameters = {
      ...this.listParameters,
      ...data,
    };

    // Detect if User changed Period (startDate/endDate) by comparing normalized dates
    const currentStartDate = this.normalizeFilterDate(this.listParameters.startDate);
    const currentEndDate = this.normalizeFilterDate(this.listParameters.endDate);
    const isPeriodChanged =
      (data.startDate !== undefined || data.endDate !== undefined) &&
      (previousStartDate !== currentStartDate || previousEndDate !== currentEndDate);

    // Preserve moduleId to avoid losing bank selection on header filter updates
    if (
      this.listParameters.moduleId === undefined ||
      this.listParameters.moduleId === null
    ) {
      this.listParameters.moduleId =
        previousModuleId ?? (Guid.EMPTY as unknown as Guid);
    }

    if (this.listParameters.format) {
      this.export(this.listParameters.format, this.listParameters.isPrint);
      this.cancelSelectionClick();
      this.triggerHeaderChange.next(this.listParameters);
      return;
    }

    this.cancelSelectionClick();
    let isCashCalledInMainBranch = false;
    if (this.isBankDetails && !this.isCash) {
      // Bank panel active: call bank API
      this.getList();
    } else {
      // Cash panel active: call cash API
      this.isBankDetails = false;
      this.getCashInHandList();
      isCashCalledInMainBranch = true;
    }

    // On Period change, ensure cash API is refreshed even when bank panel is active
    if (isPeriodChanged && !isCashCalledInMainBranch) {
      this.refreshCashInHandOnPeriodChange();
    }

    this.triggerHeaderChange.next(this.listParameters);
  }

  /** Convert date to yyyy-MM-dd format for safe period-change comparison */
  private normalizeFilterDate(date: any): string {
    return this.datepipe.transform(date, 'yyyy-MM-dd')?.toString() ?? '';
  }

  /** Force refresh Cash in Hand API when Period changes, even if Bank panel is currently active.
   * This ensures cashInHandlist is called every time Period is modified with updated startDate/endDate */
  private refreshCashInHandOnPeriodChange(): void {
    if (
      this.listParameters.moduleId === undefined ||
      this.listParameters.moduleId === null
    ) {
      this.listParameters.moduleId = Guid.EMPTY as unknown as Guid;
    }

    // Dispatch cash API call with current period dates from listParameters
    this.store
      .dispatch(new GetCashInHandTrasnactions(this.getParamter()))
      .subscribe((res) => {
        this.cashInHandTransactions = res.bankOverview.getCashInHandTransactions;
        this.cashInHandTransactions.forEach(item => {
          this.commonService
            .isDataInLockedPeriod([item.id], item.moduleId)
            .subscribe(isLocked => {
              item.isPeriodLocked = !isLocked;
            });
        });
        this.cashInHandnoDataFound = this.cashInHandTransactions.length > 0 ? false : true;
        this.cashInHandDetails = res.bankOverview.cashInHandDetails;
      });
  }

  printClick(): void {
    this.export(ExportType.PDF, true);
    this.cancelSelectionClick();
  }

  onButtonClick(element: any, actionType: ActionType): void {
    let id = element.id;

    this.ids = [];
    this.ids.push(id);

    this.commonService
      .isDataInLockedPeriod(this.ids, element.moduleId)
      .subscribe((isValidPeriod) => {
        if (
          isValidPeriod ||
          actionType === ActionType.Email ||
          actionType === ActionType.Export ||
          actionType === ActionType.View
        ) {
          switch (actionType) {
            case ActionType.Update:
              this.commonService.toggleMenu = false;

              if (element.moduleId === Modules.BankTransfer) {
                this.commonService.onEditRouting(
                  true,
                  element.moduleId,
                  id,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  element.isPeriodLocked
                );
              } else {
                this.commonService.onEditRouting(
                  true,
                  element.moduleId,
                  id,
                  undefined,
                  undefined,
                  undefined,
                  this.customId
                );
              }
              break;

            case ActionType.Delete:
              this.onDeleteClick(id, element.moduleId);
              break;
          }
        } else {
          this.commonService.onFailure(
            NotificationTextMessage.dataInLockedPeriod
          );
        }
      });
  }

  onDeleteClick(id: any, moduleId: number): void {
    this.ids = [];
    this.ids.push(id);

    if (this.ids.length > 0) {
      this.dialog
        .open(ConfirmationBoxComponent, {
          data: {
            ids: this.ids,
            type: ConfirmationType.Delete,
            moduleId: moduleId,
            totalNumberOfRecordSelected: this.ids.length,
            headerText: NotificationHeader.deleteConfirmation,
            detailText: NotificationDetails.deleteAllDetailText,
          },
        })
        .afterClosed()
        .subscribe((result) => {
          if (result) {
            this.ids = [];
            this.refreshActiveGridAfterDelete();

            const params = {
              customId: this.listParameters.moduleId,
            };
            this.isQuickAdd(params);
          }
        });
    }
  }

  allowCloseOnClickOut(): void {
    this.selectedRowIndex = -1;
  }

  onToggleMatMenu(i): void {
    this.selectedRowIndex = i;
  }

  redirect(id: any, moduleId: number, isPeriodLocked: boolean): void {
    if (moduleId > 0) {
      if (moduleId === Modules.FundList) {
        this.commonService.onEditRouting(true, Modules.ReportDetailsList, id);
      } else if (
        moduleId === Modules.Customers ||
        moduleId === Modules.Donors ||
        moduleId === Modules.Suppliers
      ) {
        this.commonService.onEditRouting(true, moduleId, id);
      } else if (
        moduleId === Modules.Invoices ||
        moduleId === Modules.Bills ||
        moduleId === Modules.CreditNote ||
        moduleId === Modules.DebitNote ||
        moduleId === Modules.FixedAssets ||
        moduleId === Modules.Quotation ||
        moduleId === Modules.Journals ||
        moduleId === Modules.Receipt ||
        moduleId === Modules.Payment ||
        moduleId === Modules.Donations
      ) {
        const ids = [id]; 
        this.commonService
          .isDataInLockedPeriod(ids, moduleId)
          .subscribe((isValidPeriod) => {

            const data = {
              moduleId,
              id,
              isPeriodLocked: isValidPeriod 
            };

            this.dialog
              .open(ViewReceiptComponent, {
                data,
                disableClose: true,
              })
              .afterClosed()
              .subscribe((result) => {});
        });
      } else {
        this.commonService.onEditRouting(
          true,
          moduleId,
          id,
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          isPeriodLocked
        );
      }
    }
  }

  isQuickAdd(event): void {
    if (event) {
      this.dashboard.getAllBankAccount(event.customId);
    }
  }

  selectAll(event: any): void {
    if (this.isBankDetails) {
      this.bankTransactions.forEach((x) => {
        x.isSelected = event.checked;
      });
    } else {
      this.cashInHandTransactions.forEach((x) => {
        x.isSelected = event.checked;
      });
    }
    this.showFooter();
  }

  showFooter(): void {
    this.selectedIds();
    this.totalSelectedRecords = this.ids.length;
  }

  selectedIds(): void {
    this.ids = [];
    if (this.isBankDetails) {
      this.bankTransactions.forEach((element) => {
        if (element.isSelected) {
          this.ids.push(element.id);
        }
      });
    } else {
      this.cashInHandTransactions.forEach((element) => {
        if (element.isSelected) {
          this.ids.push(element.id);
        }
      });
    }
  }

  deleteClick(): void {
    this.selectedIds();
    this.commonService
      .isDataInLockedPeriod(
        this.ids,
        this.listParameters.filter as unknown as Modules
      )
      .subscribe((isValidPeriod) => {
        if (this.ids.length > 0 && isValidPeriod) {
          this.dialog
            .open(ConfirmationBoxComponent, {
              data: {
                ids: this.ids,
                type: ConfirmationType.Delete,
                moduleId: this.listParameters.filter as unknown as Modules,
                totalNumberOfRecordSelected: this.ids.length,
                headerText: NotificationHeader.deleteConfirmation,
                detailText: NotificationDetails.deleteAllDetailText,
              },
            })
            .afterClosed()
            .subscribe((result) => {
              if (result) {
                this.refreshActiveGridAfterDelete();
                this.cancelSelectionClick();
              }
            });
        } else {
          this.commonService.onFailure(
            NotificationTextMessage.dataInLockedPeriod
          );
        }
      });
  }

  private refreshActiveGridAfterDelete(): void {
    this.isHeaderChange = false;

    if (this.isBankDetails) {
      this.getList();
    } else {
      this.getCashInHandList();
    }

    // Always refresh cash in hand API after delete for balance consistency
    this.getCashInHandList();
  }

  onCheckBoxSelected(element: any, event: any): void {
    element.isSelected = event.checked;

    this.isAllSelected = this.bankTransactions.every(
      (item: any) => item.isSelected === true
    );
    this.showFooter();
  }

  cancelSelectionClick(): void {
    this.deSelectAll();
  }

  deSelectAll(): void {
    this.bankTransactions?.forEach((x) => (x.isSelected = false));
    this.isAllSelected = false;
    this.totalSelectedRecords = 0;
    this.ids = [];
  }

  onPanelHeaderClick(): void {
    this.isExpanded = true;
    this.isBankDetails = true;
    this.isBankAccordionExpanded = true;
    this.isCashAccordionExpanded = false;

    if (this.dashboard) {
      this.dashboard.expandPanel();
    }
    this.triggerBankDetails();
  }

  getCashInHandList(): void {
    // Default moduleId to Guid.EMPTY if not set; cash API accepts this for global cash in hand view
    if (
      this.listParameters.moduleId === undefined ||
      this.listParameters.moduleId === null
    ) {
      this.listParameters.moduleId = Guid.EMPTY as unknown as Guid;
    }

    this.spinner.show();
    this.store
      .dispatch(new GetCashInHandTrasnactions(this.getParamter()))
      .pipe()
      .subscribe((res) => {
        this.cashInHandTransactions = res.bankOverview.getCashInHandTransactions;
        this.cashInHandTransactions.forEach(item => {
          this.commonService
            .isDataInLockedPeriod([item.id], item.moduleId)
            .subscribe(isLocked => {
            item.isPeriodLocked = !isLocked; 
            });
        });
        this.cashInHandnoDataFound = this.cashInHandTransactions.length > 0 ? false : true;
        this.cashInHandDetails = res.bankOverview.cashInHandDetails;
        const param = {
          pageSize: this.listParameters.pageSize,
          totalRecord: res.bankOverview.cashInHandtotalRecord,
          isHeaderChange: this.isHeaderChange,
        };
        this.triggerPaginationChange.next(param);
        this.isCash = false;
        this.commonService.removeItemLocalStorage('isCashinhand');
      });
  }

  triggerCashInHand(): void {
    this.isExpanded = false;
    this.isBankDetails = false;
    this.isBankAccordionExpanded = false;
    this.isCashAccordionExpanded = true;
    this.spinner.show();
    this.listParameters.pageNumber = 1;
    this.isBankDetails = false;
    if(!this.listParameters.moduleId){
    this.listParameters.moduleId =(Guid.EMPTY as unknown as Guid);
    }
    this.triggerTabChange.next(this.isBankDetails);
    this.getCashInHandList();
  }

  triggerBankDetails(): void {
    this.listParameters.pageNumber = 1;
    this.isBankDetails = true;
    this.dashboard.triggerData();
  }

  public calculateReceiptTotal() {
    if(this.isBankDetails){
      if(this.bankTransactions){
        return parseFloat(this.bankTransactions.reduce(
          (accum, curr) => accum + curr.reciepts,
          0).toFixed(2)
        );
      }else{
        return 0;
      }
    }else{
      if(this.cashInHandTransactions){
        return parseFloat(this.cashInHandTransactions.reduce(
          (accum, curr) => accum + curr.reciepts,
          0).toFixed(2)
        );
      }else{
        return 0;
      }
    }
  }

  public calculatePaymentTotal() {
    if(this.isBankDetails){
    if(this.bankTransactions){
    return parseFloat(this.bankTransactions.reduce(
      (accum, curr) => accum + curr.payments,
      0).toFixed(2)
    );
  }else{
      return 0;
    }
  }else{
    if(this.cashInHandTransactions){
      return parseFloat(this.cashInHandTransactions.reduce(
        (accum, curr) => accum + curr.payments,
        0).toFixed(2)
      );
    }else{
        return 0;
      }
  }
  }

  public calculateCashInHandBalanceTotal(): number {
    if (
      this.cashInHandDetails &&
      this.cashInHandDetails.balance !== undefined &&
      this.cashInHandDetails.balance !== null
    ) {
      return parseFloat(Number(this.cashInHandDetails.balance).toFixed(2));
    }

    if (this.cashInHandTransactions) {
      return parseFloat(
        this.cashInHandTransactions
          .reduce((accum, curr) => accum + curr.reciepts - curr.payments, 0)
          .toFixed(2)
      );
    }

    return 0;
  }
}
